<section class="ref-view">
    <div class="ref-panel">
        <div class="ref-panel-h">
            <div>
                <h2>Campaigns</h2>
                <p>Festive or promotional offers. While one is active, partners see a "Top Mitras" leaderboard on their dashboard.</p>
            </div>
            <div class="ref-tools">
                <select class="ref-inp" aria-label="Filter by status" [(ngModel)]="status" (ngModelChange)="onFilter()">
                    <option value="">All statuses</option>
                    <option value="ACTIVE">Active</option>
                    <option value="INACTIVE">Inactive</option>
                </select>
                <button class="btn btn-primary" type="button" (click)="openNew()">
                    <i class="fas fa-plus mr-50"></i>New campaign
                </button>
            </div>
        </div>

        <div class="ref-tbl-wrap">
            <table>
                <thead>
                <tr>
                    <th>Campaign</th><th>Code</th><th>Starts</th><th>Ends</th><th>Status</th><th></th>
                </tr>
                </thead>
                <tbody>
                <tr class="ref-click" *ngFor="let x of pageRows" tabindex="0" (click)="openEdit(x)" (keydown.enter)="openEdit(x)">
                    <td><b>{{x.name}}</b><small *ngIf="x.description">{{x.description}}</small></td>
                    <td>{{x.code}}</td>
                    <td>{{fmt(x.startAt)}}</td>
                    <td>{{fmt(x.endAt)}}</td>
                    <td>
                        <span class="ref-pill" [ngClass]="isRunning(x) ? 'p-active' : (x.status === 'ACTIVE' ? 'p-pending' : 'p-none')">
                            {{isRunning(x) ? 'Running now' : (x.status === 'ACTIVE' ? 'Active (scheduled)' : 'Inactive')}}
                        </span>
                    </td>
                    <td>
                        <button class="btn btn-sm" type="button" (click)="toggleStatus(x, $event)"
                                [ngClass]="x.status === 'ACTIVE' ? 'btn-outline-danger' : 'btn-outline-success'">
                            {{x.status === 'ACTIVE' ? 'Deactivate' : 'Activate'}}
                        </button>
                    </td>
                </tr>
                <tr *ngIf="!loading && !pageRows.length">
                    <td colspan="6" class="ref-empty">No campaigns yet. Create one to show "Top Mitras" on the referral panel.</td>
                </tr>
                <tr *ngIf="loading">
                    <td colspan="6" class="ref-empty">Loading…</td>
                </tr>
                </tbody>
            </table>
        </div>
        <app-ref-pager [total]="total" [page]="page" [per]="per" (pageChange)="onPageChange($event)"></app-ref-pager>
    </div>

    <app-ref-drawer [open]="drawerOpen" [title]="editingId ? 'Edit campaign' : 'New campaign'"
                    sub="Shown to partners only while Status is Active and the current date is within the start/end window."
                    (closed)="close()">
        <ng-container *ngIf="drawerOpen">
            <form novalidate>
                <div class="form-group">
                    <label for="campName">Name</label>
                    <input class="form-control" id="campName" type="text" [(ngModel)]="draft.name" name="campName" placeholder="Diwali Dhamaka">
                </div>

                <div class="form-group">
                    <label for="campCode">Code</label>
                    <input class="form-control" id="campCode" type="text" [(ngModel)]="draft.code" name="campCode" placeholder="DIWALI2026" style="text-transform: uppercase;">
                </div>

                <div class="form-group">
                    <label for="campDesc">Description (optional)</label>
                    <textarea class="form-control" id="campDesc" rows="2" [(ngModel)]="draft.description" name="campDesc" placeholder="Festive referral campaign"></textarea>
                </div>

                <div class="form-group">
                    <label for="campStart">Starts (optional — leave blank for immediately)</label>
                    <input class="form-control" id="campStart" type="datetime-local" [(ngModel)]="draft.startAt" name="campStart">
                </div>

                <div class="form-group">
                    <label for="campEnd">Ends (optional — leave blank for no end date)</label>
                    <input class="form-control" id="campEnd" type="datetime-local" [(ngModel)]="draft.endAt" name="campEnd">
                </div>

                <div class="form-group">
                    <label for="campStatus">Status</label>
                    <select class="form-control" id="campStatus" [(ngModel)]="draft.status" name="campStatus">
                        <option value="ACTIVE">Active</option>
                        <option value="INACTIVE">Inactive</option>
                    </select>
                </div>

                <small *ngIf="error" class="text-danger">{{error}}</small>

                <div class="ref-acts">
                    <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
                    <button class="btn btn-primary" type="button" (click)="save()" [disabled]="saving">
                        {{editingId ? 'Save changes' : 'Create campaign'}}
                    </button>
                </div>
            </form>
        </ng-container>
    </app-ref-drawer>
</section>
